<template>
    <main>
        <inncosys-breadcrumbs :history="pathHistory"></inncosys-breadcrumbs>
        <div class="row">
            <div class="col l12">
                <div class="row">
                  <div class="col l4 input-field">
                    <inncosys-sucursales-select-name v-model="selectedStore" >
                    </inncosys-sucursales-select-name >
                  </div>

                  <div class="col l2 input-field">
                    
                    <inncosys-select id="numAnio" v-model="numAnio" :dataSetReady="true" label="Año">
                      <option v-for="year in years" v-bind:key="year" >{{year}}</option>
                    </inncosys-select>

                  </div>
                  <div class="col l2 input-field hide-on-small-only">
                      <inncosys-select id="numAnio" v-model="numSemana" :dataSetReady="true" label="Semana">
                      <option v-for="week in weeks" v-bind:key="week" >{{week}}</option>
                    </inncosys-select>
                
                    
                  </div>
                  <div class="col l2 input-field show-on-small hide-on-med-and-up">
                    <input placeholder="32" id="numSemana" type="number" class="validate" v-model="numSemana" >
                    <label for="numSemana">N° Semana</label>
                  </div>
                  <div class="col l2 input-field  valign-wrapper">
                    <p class="center-align">{{fechaConsultaInicio | dateFilter}}</p>
                  </div>
                  <div class="col l2 input-field valign-wrapper">
                    <p class="center-align">{{fechaConsultaFin | dateFilter}}</p>
                  </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col l12 s12">
                <div >
                  <div v-if="loadingResults" class="progress">
                      <div class="indeterminate"></div>
                  </div>
                    <datatable title="Resultados Indicadores" :columns="columns" :rows="rows" v-on:row-click="openKpiDetails"></datatable>
                </div>
            </div>
        </div>
         <div class="row">
          <div class="col l16  s12">
            <div class="card" id="tacometroOcupacion"></div>
          </div>
          <div class="col l16  s12">
            <div class="card" id="detalleOcupacion"></div>
          </div>
        </div>
    </main>
</template>
<script>
import * as Highcharts from "highcharts";
import { kpiOcupacion } from "../../../controllers/mantenimiento/ocupacion.js";
import { csvExport } from "../../../controllers/commun/csv-export.js";
import { db } from "../../../main";

import DataTable from 'vue-materialize-datatable';
import Breadcrumbs from "../../../components/commun/Breadcrumbs.vue";
import SucursalesSelectName from "../../../components/commun/SucursalesSelectName.vue";
import Select from "../../../components/commun/forms/Select.vue";
import DatePicker from "../../../components/commun/forms/DatePicker.vue";

require("highcharts/highcharts-more")(Highcharts);

const moment = require("moment");
export default {
  created() {
    for (var i = moment().year(); i > moment().year() - 5; i--) {
      this.years.push(i);
    }
    for (var i = 1; i < 54; i++) {
      this.weeks.push(i);
    }
  },
  mounted() {
    this.kpiOcupacionInstance = new kpiOcupacion();
    this.csvExportInstance = new csvExport();
  },
  filters: {
    dateFilter(value) {
      if (!value) return "";
      return moment(value).format("DD-MM-YYYY");
    }
  },
  components: {
    inncosysBreadcrumbs: Breadcrumbs,
    inncosysSucursalesSelectName: SucursalesSelectName,
    inncosysDatePicker: DatePicker,
    datatable: DataTable,
    inncosysSelect: Select
  },
  data() {
    return {
      numSemana: 1,
      numAnio: moment().year(),
      years: [],
      weeks: [],
      kpiOcupacionInstance: null,
      csvExportInstance: null,
      Highcharts: null,
      pathHistory: [
        { name: "Inicio", route: "/" },
        {
          name: "Tablero Operaciones",
          route: "/tablero-operaciones/operaciones"
        }
      ],
      selectedStore: "",
      fechaConsultaInicio: null,
      fechaConsultaFin: null,
      columns: [
        {
          label: "Nombre", // Column name
          field: "nombre", // Field name from row
          numeric: false, // Affects sorting
          html: false // Escapes output if false.
        },
        {
          label: "UM", // Column name
          field: "um", // Field name from row
          numeric: false, // Affects sorting
          html: false // Escapes output if false.
        },
        {
          label: "Frecuencia", // Column name
          field: "frecuencia", // Field name from row
          numeric: false, // Affects sorting
          html: false // Escapes output if false.
        },
        {
          label: "PB", // Column name
          field: "pb", // Field name from row
          numeric: false, // Affects sorting
          html: false // Escapes output if false.
        },
        {
          label: "Objetivo", // Column name
          field: "objetivo", // Field name from row
          numeric: false, // Affects sorting
          html: false // Escapes output if false.
        },
        {
          label: "Real", // Column name
          field: "real", // Field name from row
          numeric: false, // Affects sorting
          html: false // Escapes output if false.
        }
      ],
      rows: [],
      vehicles: {},
      loadingResults: false,
      vehiclesInOperationUnit: [],
      allVehicles: [],
      allRentedVehicles: {},
      allStock: [],
      vehicleCounter: {}
    };
  },
  watch: {
    numSemana(value) {
      this.fechaConsultaInicio = moment()
        .year(numAnio)
        .day("Monday")
        .week(value)
        .startOf("day")
        .toDate();
      this.fechaConsultaFin = moment()
        .day("Monday")
        .week(value)
        .startOf("day")
        .add(1, "week")
        .add(-1, "second")
        .toDate();
      const vueInstance = this;
      if (
        (this.fechaConsultaInicio != null,
        this.fechaConsultaFin != null && this.selectedStore != null)
      ) {
        console.log("about to get results");
        this.obtenerOcupacionPeriodo();
      }
    },
    selectedStore(value) {
      if (
        (this.fechaConsultaInicio != null,
        this.fechaConsultaFin != null && this.selectedStore != null)
      ) {
        console.log("about to get results");
        this.obtenerOcupacionPeriodo();
      }
    }
  },
  methods: {
    obtenerOcupacionPeriodo() {
      this.rows = [];
      var vueInstance = this;
      var totalOcupacion = {};

      db.ref("data")
        .child("ocupacion")
        .child(this.selectedStore)
        .orderByKey()
        .startAt(moment(this.fechaConsultaInicio).valueOf() + "")
        .endAt(moment(this.fechaConsultaFin).valueOf() + "")
        .once("value")
        .then(ocupacionFamiliasSnapShot => {
          var countRegistros = ocupacionFamiliasSnapShot.numChildren();
          ocupacionFamiliasSnapShot.forEach(ocupacionFamiliaDiaSnapShot => {
            ocupacionFamiliaDiaSnapShot.forEach(equiposFamilia => {
              equiposFamilia.forEach(estado => {
                if (!totalOcupacion[estado.key]) totalOcupacion[estado.key] = 0;
                totalOcupacion[estado.key] += estado.val();
              });
            });
          });
          vueInstance.obtenerIndicadores(totalOcupacion, countRegistros);
        });
    },
    obtenerIndicadores(sumEquipos, registrosCount) {
      var totalEquipos = Object.values(sumEquipos).reduce(function(a, b) {
        return a + b;
      }, 0);
      var promedioEquipos = parseInt(totalEquipos / registrosCount);
      this.rows.push({
        real: promedioEquipos,
        nombre: "Equipos",
        um: "U",
        pb: "-",
        frecuencia: "-",
        objetivo: "-"
      });
      const ocupacion =
        totalEquipos == 0
          ? 0
          : (((sumEquipos.rentado +
              sumEquipos.rentado_servicio +
              sumEquipos.entrega) /
              registrosCount) *
              100) /
            promedioEquipos;
      this.rows.push({
        real: ocupacion.toFixed(2),
        nombre: "Ocupación",
        um: "%",
        pb: "-",
        frecuencia: "-",
        objetivo: "-"
      });

      const mantenimiento =
        totalEquipos == 0
          ? 0
          : ((sumEquipos.servicio_taller / registrosCount) * 100) /
            promedioEquipos;
      this.rows.push({
        real: mantenimiento.toFixed(2),
        nombre: "En Mantenimiento",
        um: "%",
        pb: "-",
        frecuencia: "-",
        objetivo: "-"
      });
      this.obtenerGraficas(ocupacion.toFixed(2), sumEquipos, registrosCount);
    },
    obtenerGraficas(ocupacion, sumEquipos, registrosCount) {
      this.createChartDisponibilidad(parseFloat(ocupacion));
      const priorities = {
        rentado: 0,
        rentado_servicio: 1,
        entrega: 2,
        recoger: 3,
        disponible: 4,
        servicio_taller: 5
      };
      const colors = {
        rentado: "#1b5e20",
        rentado_servicio: "#fdd835",
        entrega: "#4c8c4a",
        recoger: "#212121",
        disponible: "#0277bd",
        servicio_taller: "#b71c1c"
      };
      const dataArr = [];
      const values = Object.keys(sumEquipos);
      values.forEach(value => {
        const serie = {
          name: value,
          priority: priorities[value],
          color: colors[value]
        };

        if (
          serie.name == "rentado" ||
          serie.name == "rentado_servicio" ||
          serie.name == "entrega"
        ) {
          serie.data = [parseInt(sumEquipos[value] / registrosCount), 0, 0, 0];
        } else if (serie.name == "disponible") {
          serie.data = [0, parseInt(sumEquipos[value] / registrosCount), 0, 0];
        } else if (serie.name == "servicio_taller") {
          serie.data = [0, 0, parseInt(sumEquipos[value] / registrosCount), 0];
        } else if (serie.name == "recoger") {
          serie.data = [0, 0, 0, parseInt(sumEquipos[value] / registrosCount)];
        }
        dataArr.push(serie);
        dataArr.sort((a, b) => {
          if (a.priority > b.priority) return 1;
          if (a.priority == b.priority) return 0;
          return -1;
        });
      });
      this.createChartDetalleDisponibilidad(dataArr);
    },
    openKpiDetails(row) {
      console.log("row clicked", row);
      this.csvExportInstance.downloadCSV({
        filename: "unit-data.csv",
        data: row.units
      });
      // this.modalDetailsInstace.open();
    },

    createChartDetalleDisponibilidad(dataArr) {
      console.log(dataArr);
      Highcharts.chart("detalleOcupacion", {
        chart: {
          type: "bar"
        },
        title: {
          text: "Ocupación"
        },
        xAxis: {
          categories: ["Ocupación", "Disponible", "Servicio", "Recoger"]
        },
        yAxis: {
          min: 0,
          title: {
            text: "Total de unidades"
          }
        },
        legend: {
          reversed: true
        },
        plotOptions: {
          series: {
            stacking: "normal"
          }
        },
        series: dataArr
      });
    },
    createChartDisponibilidad(ocupacion) {
      Highcharts.chart("tacometroOcupacion", {
        chart: {
          type: "gauge",
          plotBackgroundColor: null,
          plotBackgroundImage: null,
          plotBorderWidth: 0,
          plotShadow: false
        },
        title: {
          text: "Ocupación"
        },
        pane: {
          startAngle: -150,
          endAngle: 150,
          background: [
            {
              backgroundColor: {
                linearGradient: {
                  x1: 0,
                  y1: 0,
                  x2: 0,
                  y2: 1
                },
                stops: [[0, "#FFF"], [1, "#333"]]
              },
              borderWidth: 0,
              outerRadius: "109%"
            },
            {
              backgroundColor: {
                linearGradient: {
                  x1: 0,
                  y1: 0,
                  x2: 0,
                  y2: 1
                },
                stops: [[0, "#333"], [1, "#FFF"]]
              },
              borderWidth: 1,
              outerRadius: "107%"
            },
            {
              // default background
            },
            {
              backgroundColor: "#DDD",
              borderWidth: 0,
              outerRadius: "105%",
              innerRadius: "103%"
            }
          ]
        },

        // the value axis
        yAxis: {
          min: 0,
          max: 100,

          minorTickInterval: "auto",
          minorTickWidth: 1,
          minorTickLength: 10,
          minorTickPosition: "inside",
          minorTickColor: "#666",

          tickPixelInterval: 30,
          tickWidth: 2,
          tickPosition: "inside",
          tickLength: 10,
          tickColor: "#666",
          labels: {
            step: 2,
            rotation: "auto"
          },
          title: {
            text: "%"
          },
          plotBands: [
            {
              from: 0,
              to: 20,
              color: "#DF5353"
            },
            {
              from: 21,
              to: 75,
              color: "#DDDF0D"
            },
            {
              from: 76,
              to: 85,
              color: "#55BF3B"
            },
            {
              from: 86,
              to: 100,
              color: "#DF5353"
            }
          ]
        },

        series: [
          {
            name: "Ocupación",
            data: [ocupacion],
            tooltip: {
              valueSuffix: " %"
            }
          }
        ]
      });
    }
  }
};
</script>
<style scoped>
</style>
